import React, { useEffect, useState } from "react";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";
import Form, { Group } from "~/common/components/Form";
import DatePicker from "~/common/components/DatePicker";
import {
	INDUSTRY_CATEGORY_LIST,
	INVESTMENT_SCALE,
	STATUS_SCALE,
	TRANS_INDUSTRY_CATEGORY_LIST,
} from "~/constant/ApplyFormConstant";
import { useTranslation } from "react-i18next";
import "../../../assets/sass/pages/common/searchFilter.scss";

const SearchFilter = ({ setSearchElement, applyListForm, handleSearch }) => {
	const [alertFive, setAlertFive] = useState([]);
	const [totalTag, setTotalTag] = useState([]);
	const [indSearch, setIndSearch] = useState([]);
	const [scaleSearch, setScaleSearch] = useState([]);
	const [statusSearch, setStatusSearch] = useState([]);
	const [indValueList, setIndValueList] = useState([]);
	const [scaleValueList, setScaleValueList] = useState([]);
	const [statusValueList, setStatusValueList] = useState([]);
	const [toggleIndus, setToggleIndus] = useState("toggleClose");
	const [toggleScale, setToggleScale] = useState("toggleClose");

	const startDate = applyListForm.watch("applyStartDate");
	const endDate = applyListForm.watch("applyEndDate");
	const { t } = useTranslation();

	useEffect(() => {
		setSearchElement({ indSearch, scaleSearch, statusSearch });
	}, [indSearch, scaleSearch, statusSearch]);

	// 투자 단계, 산업 분야 객체 배열 setter
	useEffect(() => {
		setIndValueList(INDUSTRY_CATEGORY_LIST);
		setScaleValueList(INVESTMENT_SCALE);
		setStatusValueList(STATUS_SCALE);
	}, []);

	// 검색 항목에 태그 만드는 totalTag 구성 및 검색 항목 구성
	useEffect(() => {
		const searchIndus = indValueList.filter((d) => Object.values(d)[0] === true);
		const searchScale = scaleValueList.filter((d) => Object.values(d)[0] === true);
		const searchStatus = statusValueList.filter((d) => Object.values(d)[0] === true);
		setIndSearch(searchIndus.map((d) => Object.keys(d)[0]));
		setScaleSearch(searchScale.map((d) => d.value));
		setStatusSearch(searchStatus.map((d) => Object.keys(d)[0]));
		setTotalTag([...searchIndus, ...searchScale, ...searchStatus]);
	}, [indValueList, scaleValueList, statusValueList]);

	useEffect(() => {
		handleSearch && handleSearch();
	}, [startDate, endDate]);

	// 산업 분야 선택 - 5개 이상 선택시 alert 창 띄우는 로직과 연결되어있음
	const onChangeIndus = (data) => {
		const newData = indValueList.map((d) =>
			Object.keys(d)[0] === data ? alertDo(d, data) : d
		);
		setIndValueList(newData);
	};

	// 산업 분야 5개 이상 선택시 5개 이상 선택 불가 alert 창 띄우기
	const alertDo = (d, data) => {
		const duplicate = alertFive.find((da) => da === data);
		if (duplicate) {
			const except = alertFive.filter((da) => da !== data);
			setAlertFive(except);
			return { ...d, [data]: !d[data] };
		} else if (alertFive.length > 4) {
			alert(t("pages.apply.ApplyList.SearchFilter.maxIndustry"));
			return d;
		} else {
			setAlertFive(alertFive.concat(data));
			return { ...d, [data]: !d[data] };
		}
	};

	// 투자 단계 선택 - 선택 개수 제한 없음
	const onChangeScale = (data) => {
		const newData = scaleValueList.map((d) =>
			Object.keys(d)[0] === data ? { ...d, [data]: !d[data] } : d
		);
		setScaleValueList(newData);
	};

	// 투자 상태 선택 - 선택 개수 제한 없음
	const onChangeStatus = (data) => {
		const newData = statusValueList.map((d) =>
			Object.keys(d)[0] === data ? { ...d, [data]: !d[data] } : d
		);
		setStatusValueList(newData);
	};

	// 태그 x 누르면 검색 항목 제외 및 check false
	const deleteTag = (data) => {
		onChangeIndus(data);
		onChangeScale(data);
		onChangeStatus(data);
	};

	return (
		<div className="c__card searchFilter-card">
			<section className="select-section">
				<div className="select-group">
					<Form useForm={applyListForm}>
						<Group
							label={t("pages.apply.ApplyList.SearchFilter.applyDate")}
							className="datePicker-group"
						>
							<DatePicker name="applyStartDate" maxDate={endDate} />
							<span className="dash"> - </span>
							<DatePicker name="applyEndDate" minDate={startDate} />
						</Group>
					</Form>
				</div>
				<ul className={"invest-step select-group"}>
					<li className="section-title">
						{t("pages.apply.ApplyList.SearchFilter.investStatus")}
					</li>
					<li className="checkbox-group">
						{statusValueList.map((d) => {
							const keyName = d.label;
							const value = Object.keys(d)[0];
							return (
								<div className="checkbox" key={value}>
									<label className={`checkbox-custom`}>
										<input
											type="checkbox"
											onChange={() => onChangeStatus(value)}
											checked={d[value]}
											value={value}
										/>
										<span className="checkmark" />
										<span className="checkbox-label">{keyName}</span>
									</label>
								</div>
							);
						})}
					</li>
				</ul>
				<ul className={`invest-step select-group ${toggleScale}`}>
					<li className="section-title">
						{t("pages.apply.ApplyList.SearchFilter.investStep")}
					</li>
					<li className="checkbox-group">
						{scaleValueList.map((d) => {
							const keyName = Object.keys(d)[0];
							return (
								<div className="checkbox" key={keyName}>
									<label className={`checkbox-custom`}>
										<input
											type="checkbox"
											onChange={() => onChangeScale(keyName)}
											checked={d[keyName]}
											value={keyName}
										/>
										<span className="checkmark" />
										<span className="checkbox-label">{keyName}</span>
									</label>
								</div>
							);
						})}
					</li>
					<li className="checkbox-toggle-btn">
						{toggleScale === "toggleClose" ? (
							<button
								type="button"
								className={`btn-ghost ${toggleScale}`}
								onClick={() => setToggleScale("toggleOpen")}
							>
								<i className="simple-icon-plus" />{" "}
								{t("pages.apply.ApplyList.SearchFilter.seeMore")}
							</button>
						) : (
							<button
								type="button"
								className={`btn-ghost ${toggleScale}`}
								onClick={() => setToggleScale("toggleClose")}
							>
								<i className="simple-icon-minus" />{" "}
								{t("pages.apply.ApplyList.SearchFilter.close")}
							</button>
						)}
					</li>
				</ul>
				<ul className={`company-kind select-group ${toggleIndus}`}>
					<li className="section-title">
						{t("pages.apply.ApplyList.SearchFilter.industryType")}
					</li>
					<li className="checkbox-group">
						{indValueList.map((d) => {
							const keyName = Object.keys(d)[0];
							return (
								<div className="checkbox" key={keyName}>
									<label className={`checkbox-custom`}>
										<input
											type="checkbox"
											onChange={() => onChangeIndus(keyName)}
											checked={d[keyName]}
											value={keyName}
										/>
										<span className="checkmark" />
										<span className="checkbox-label">
											{TRANS_INDUSTRY_CATEGORY_LIST[keyName]}
										</span>
									</label>
								</div>
							);
						})}
					</li>
					<li className="checkbox-toggle-btn">
						{toggleIndus === "toggleClose" ? (
							<button
								type="button"
								className={`btn-ghost ${toggleIndus}`}
								onClick={() => setToggleIndus("toggleOpen")}
							>
								<i className="simple-icon-plus" />{" "}
								{t("pages.apply.ApplyList.SearchFilter.seeMore")}
							</button>
						) : (
							<button
								type="button"
								className={`btn-ghost ${toggleIndus}`}
								onClick={() => setToggleIndus("toggleClose")}
							>
								<i className="simple-icon-minus" />{" "}
								{t("pages.apply.ApplyList.SearchFilter.close")}
							</button>
						)}
					</li>
				</ul>
			</section>
			<section className="tag-section">
				<ul className="search-list">
					<li className="section-title">
						{t("pages.apply.ApplyList.SearchFilter.searchItem")}
					</li>
					<li className="tag-wrap">
						{totalTag &&
							totalTag.map((d) => {
								const keyName = Object.keys(d)[0];

								return (
									<span className="tag" key={keyName}>
										{d.label || d.value}
										<button
											type="button"
											className="delete-btn"
											onClick={() => deleteTag(keyName)}
										>
											<SolidCloseIcon />
										</button>
									</span>
								);
							})}
					</li>
				</ul>
			</section>
		</div>
	);
};

export default SearchFilter;
